import { useMemo } from "react";
import { bindActionCreators } from "@reduxjs/toolkit";
import {
  type RootState,
  useAppDispatch,
  useAppSelector,
} from "../../../store/store";
import { conversationsActions } from "../redux/slice";
import conversationsThunk from "../redux/thunk";

export const useConversations = () => {
  const {
    conversations,
    error,
    search,
    selected_conversation,
    unreadConversations,
    pagination,
    total_unread_message_count
  } = useAppSelector((state: RootState) => state.conversations);

  const dispatch = useAppDispatch();
  return useMemo(() => {
    const actions = {
      ...conversationsActions,
      ...conversationsThunk,
    };
    return {
      ...bindActionCreators(actions, dispatch),
      conversations,
      search,
      error,
      pagination,
      selected_conversation,
      unreadConversations,
      total_unread_message_count
    };
  }, [
    dispatch,
    conversations,
    search,
    error,
    pagination,
    selected_conversation,
    unreadConversations,
    total_unread_message_count
  ]);
};

export default useConversations;
